import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.submitting = false;
    this.enabled = false;
    this.handleFieldChanged = this.handleFieldChanged.bind(this);

    window.addEventListener("search-field:changed", this.handleFieldChanged);
    this.enableFrame = requestAnimationFrame(() => {
      this.enabled = true;
    });
  }

  disconnect() {
    window.removeEventListener("search-field:changed", this.handleFieldChanged);
    cancelAnimationFrame(this.enableFrame);
  }

  handleFieldChanged(event) {
    if (!this.enabled || this.submitting) return;
    if (event.detail?.field !== "address") return;

    const source = event.detail?.source;
    if (!(source instanceof Element) || !this.element.contains(source)) return;
    if (!this.hasAllSearchFields()) return;

    this.submitting = true;
    requestAnimationFrame(() => this.element.requestSubmit());
  }

  hasAllSearchFields() {
    return this.hasActivity() && this.hasAge() && this.hasAddress();
  }

  hasActivity() {
    return Array.from(
      this.element.querySelectorAll("input[name='activity_id[]']")
    ).some((input) => input.checked && input.value.trim() !== "");
  }

  hasAge() {
    const input = this.element.querySelector("input[name='age']");
    const value = parseInt(input?.value, 10);

    return Number.isInteger(value) && value > 0;
  }

  hasAddress() {
    const input = this.element.querySelector("input[name='address']");

    return input?.value.trim().length > 0;
  }
}
